<template>
<v-container fluid dense>
  <v-tabs v-model="pagina">
    <v-tab v-for="zona in zone" :key="zona.codice" :href="`#tab-${zona.codice}`">
      {{ zona.descrizione }}
    </v-tab>
  </v-tabs>
  <v-tabs-items v-model="pagina">
    <v-tab-item v-for="zona in zone" :key="zona.codice" :value="`tab-${zona.codice}`">
      <v-data-table
        v-model="selected"
        :show-select="numeroParcheggiZona(zona) > 0"
        item-key="_id"
        :headers="headers"
        :items="parcheggiZona(zona)"
        :options.sync="options"
        :loading="loading"
        class="elevation-1"
        :disable-sort="true"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, 100]
        }"
        :single-expand="singleExpand"
        show-expand
        dense
      >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Posizione occupate</v-toolbar-title><v-btn icon @click="onRefresh" title="Aggiorna"><v-icon>mdi-refresh</v-icon></v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:[`item.parcheggio.data`]="{ item }">
        {{ item.parcheggio && item.parcheggio.data | dateTime }}
      </template>      
<!--       <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" title="Modifica il prodotto">mdi-pencil</v-icon>
        <v-icon small class="mr-2" @click="duplicateItem(item)" title="Duplica il prodotto">mdi-content-duplicate</v-icon>
        <v-icon small class="mr-2" @click="deleteItemWithPassword(item)" title="Cancella il prodotto">mdi-delete</v-icon>
      </template> -->
      <template v-slot:no-data>
        <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="td-park-selected">         
          <v-tabs dense v-model="tab[item._id]">
            <v-tab>Articoli contenuti</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab[item._id]">
            <v-tab-item>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Codice</th>
                      <th class="text-left" width="40%">Descrizione</th>
                      <th v-if="tagliaColore" class="text-left">Taglia</th>
                      <th v-if="tagliaColore" class="text-left">Colore</th>
                      <th class="text-left">UM</th>
                      <th class="text-left">Quantità</th>
                      <!-- <th class="text-left">Prezzo</th> -->
                      <th class="text-right"><v-badge dot title="Il valore è modificabile">Prezzo</v-badge></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(rc, idx) in item.righe" :key="idx">
                      <td>{{ rc.codice }}</td>
                      <td>{{ rc.descrizione }}</td>
                      <td v-if="tagliaColore">{{ rc.variante1 }}</td>
                      <td v-if="tagliaColore">{{ rc.variante2 }}</td>
                      <td>{{ rc.magazzino && rc.magazzino.unitaMisura }}</td>
                      <td>{{ rc.quantita }}</td>
                      <!-- <td>{{ rc.prezzo | euro }}</td> -->
                      <td class="text-right" title="Modifica prezzo">
                        <v-edit-dialog :return-value.sync="rc.prezzo" large persistent cancel-text="Annulla" save-text="Salva" @save="onSavePrezzo(rc, item)">
                          {{ rc.prezzo | euro }}
                          <template v-slot:input>
                            <div class="mt-4 text-h6">Prezzo prodotto</div>
                            <v-text-field v-model="rc.prezzo" label="Valore" single-line autofocus :rules="[numerico]"></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td>
                        <v-icon small class="" @click="onCalculator(rc, item)" title="Dettaglio prezzi e acquisti">mdi-calculator</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-tab-item>
          </v-tabs-items>
        </td>
      </template>        
      </v-data-table>

    </v-tab-item>
  </v-tabs-items>
    <v-row justify="start">
   
    </v-row>
    <speed-dial @comando="onSpeedDialogComando"/>
    <stampa-etichette ref="stampaEtichette" />
    <dialog-prezzi :show="dialogPrezzi" :prodotto="prodottoPrezzi" :item="itemPrezzi" @aggiornaPrezzo="onAggiornaPrezzo"/>
  </v-container>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import _ from 'lodash'
  import SpeedDial from './speedDial.vue'
  import StampaEtichette from '@/components/etichette/stampaEtichette'
  import DialogPrezzi from './dialogPrezzi'
  import configurazioni from '@/services/configurazioniService'
  import scontrini from '@/services/scontriniService.js'
  import prodotti from '@/services/prodottiService'
  const labelsPath = window.appConfig.VUE_APP_MOL_S_LABELS

  export default {
    components: {
      SpeedDial,
      StampaEtichette,
      DialogPrezzi
    },
    mixins: [verificaLicenza],
    data(vm) {
      return {
        totaleArticoli: 0,
        tab: {},
        articoli: [],
        selected: [],
        loading: true,
        options: { itemsPerPage: 50 },
        headers: [
          { text: 'Nome', value: 'parcheggio.nome', align: 'start' },
          { text: 'Posizione', value: 'parcheggio.posizione', align: 'start' },
          { text: 'Stato', value: 'parcheggio.stato' },
          { text: 'Data', value: 'parcheggio.data' },
          { text: 'Num. Elementi', value: 'righe.length' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        singleExpand: false,
        dialogConferma: false,
        titoloConferma: '',
        messaggioConferma: '',
        confirmText: 'SI',
        onlyOk: false,
        onConferma: vm.modificaConfirm,
        pagina: null,
        numeroZone: 3,
        colori: null,
        zone: [],
        parcheggiati: [],
        posizione: null,
        triggerDettaglio: 1,
        tagliaColore: false,
        isModuloA4: false,
        usaQtaAnagrafica: false,
        dialogStampa: null,
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        dialogPrezzi: false,
        prodottoPrezzi: null,
        rigaPrezzi: null,
        itemPrezzi: null
      }
    },
    async mounted() {
      await this.gestioneToken()
      const impostazioni = await configurazioni.getConfigurazione('display_generale', 'parcheggio')
      this.numeroZone = impostazioni.numeroZone
      this.colori = impostazioni.colori
      const parcheggio = await configurazioni.getConfigurazione('parcheggio', 'zone')
      this.zone = parcheggio
      await this.onRefresh()
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.tagliaColore = backoffice.usaTagliaColore
    },
    methods: {
      async onCalculator(riga, item) {
        this.prodottoPrezzi = riga
        this.itemPrezzi = item
        this.dialogPrezzi = true
        await this.$nextTick()
      },
      async onAggiornaPrezzo({ listino, valore, codice, riga, item }) {
        const idRiga = item.righe.indexOf(riga)
        riga.prezzo = valore
        _.set(riga, 'listini.L1.base', valore)
        await scontrini.updateRigaScontrino(item._id, idRiga, riga)

      },      
      async onSavePrezzo(riga, item) {
        const valore = isNaN(riga.prezzo) ? '' : +parseFloat(riga.prezzo).toFixed(2)
        await this.aggiornaPrezzo(riga, item, valore, 'listino')
      },
      async aggiornaPrezzo(riga, item, valore, tipoPrezzo = 'listino') {
        prodotti.clearCache()
        const idProdotto = riga.codice
        await prodotti.aggiornaPrezzo(tipoPrezzo, idProdotto, 'L1', valore)
        const idRiga = item.righe.indexOf(riga)  
        await scontrini.updateRigaScontrino(item._id, idRiga, riga)
      },           
      numeroParcheggiZona(zona) {
        return this.parcheggiZona(zona).length
      },
      parcheggiZona(zona) {
        if (!(this.parcheggiati && zona)) {
          return []
        }
        let parcheggi = this.parcheggiati.filter(x => x.parcheggio.zona === zona.codice)
        for (let p of parcheggi) {
          const pn = zona.posizioni.find(x => x.codice === p.parcheggio.posizione)
          if (pn) {
            p.parcheggio.nome = pn.descrizione || pn.title
            p.parcheggio.data = pn.dataDescrizione || pn.data
            p.parcheggio.ordine = parseInt(pn.row)*1000 + parseInt(pn.col)
          }
        }
        return _.sortBy(parcheggi, ['parcheggio.ordine'])
      },
      async onRefresh() {
        this.loading = true
        await this.$nextTick()
        await this.aggiornaParcheggiati()
        this.loading = false
      },
      async aggiornaParcheggiati() {
        this.parcheggiati = await scontrini.getParcheggiati()
      },
      selezionaPosizione(ps) {
        this.posizione = ps
      },
      posizioneOccupata(ps) {
        const posizione = `${this.zonaPark}.${ps}`
        const occupato = this.parcheggiati.find(x => x.parcheggio.posizione === posizione)
        return occupato ? true : false
      },
      async svuotaPosizione(ps) {
        if (!this.posizioneOccupata(ps)) return
        this.posizioneDaSvuotare = ps

        this.titoloConferma = 'Svuotamento parcheggio',
        this.messaggioConferma = `Confermi eliminazione contenuto posizione: ${this.zonaPark}.${ps} ?`,

        this.dialogConferma = true
      },
      async onSvuotaPosizione() {
        const ps = this.posizioneDaSvuotare
        const posizione = `${this.zonaPark}.${ps}`
        const scontrino = this.parcheggiati.find(x => x.parcheggio.posizione === posizione)
        const idScontrino = scontrino && scontrino._id
        if (idScontrino) {
          await scontrini.annullaParcheggio(this.base, idScontrino)
          await this.onRefresh()
        }
        this.dialogConferma = false
        this.posizioneDaSvuotare = null
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'stampa-etichette':
             const se = this.$refs.stampaEtichette
            se.stampaEtichette(this.elencoEtichette(), 'articoli')
            this.annullaSelezione()
            break
          default:
            break
        }
      },
      elencoEtichette() {
        const etichette = []
        for (let s of this.selected.map(el => el.righe)) {
          for (let r of s.filter(x => x.tipo === 'prodotto')) {
            // TODO: Sistemare, se passo la qta non stampa correttamente --> inserisco n etichette in base alla quantità
            for (let q = 0; q < parseInt(r.quantita); q++) {
              etichette.push({
                id: r.codice,
                idpr: r.codice,
                quantita: 1 // parseInt(r.quantita)
              })
            }
          }
        }
        return etichette
      },
      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta, tipoStampa, report) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        // this.salta = salta
        this.dialogStampa = false
        const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'movimento'
        const documenti = this.selected
        for (let mm of documenti) {
          const filtriAggiuntivi = [{
            applicazione: 'movimenti',
            chiave: 'riferimento.id',
            testo: _.get(mm, '_id', '')
          }]
          const parametri = {
            articoli: true,
            filtri: filtriAggiuntivi,
            gruppi: [],
            tipoQuantita
          }
          const filtro = {
            start: moment(mm.data).startOf('day').format('YYYYMMDD'),
            end: moment(mm.data).endOf('day').format('YYYYMMDD')
          }
          const filtroElementi = { filtro, parametri }
          const src = `${labelsPath}/${tipoStampa}/${report}?elm=${btoa(JSON.stringify(filtroElementi))}${salta ? '&sk=' + salta : ''}${tipoQuantita ? '&tpq=' + tipoQuantita : ''}`
          const printResult = await etichetteService.stampaDiretta(tipoStampa, src)
          if (printResult.status && printResult.status === 'error') {
            this.errorTitle = ' Errore stampa etichette'
            this.errorMessage = printResult.error
            this.dialogErrore = true
          }
        }
        this.annullaSelezione()
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

  td.td-park-selected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
